import {
  LENGTH_SEE_MORE_TEXT,
  SUITABLE_TEXT_MAX_LINE,
} from '../constant/user-setting-modal-resources';

export const numberOfNewLine = (srcStr: string): number => {
  const result: number = srcStr.split('\n').length;
  return result;
};

export const maxWidthOfString = (srcStr: string): number => {
  let result: number = 0;
  srcStr.split('\n').forEach((str: string) => {
    result = str.length > result ? str.length : result;
  });
  return result;
};

export const renderNewStringWithNewLine = (
  srcStr: string,
  newLine: number,
  maxWidth: number
): string => {
  const strArr: Array<string> = srcStr.split('\n');
  let result: string = '';
  let numberOfLine = 0,
    i = 0;
  while (numberOfLine < newLine) {
    if (strArr[i].length > maxWidth) {
      numberOfLine += Math.ceil(strArr[i].length / maxWidth);
      if (numberOfLine < newLine) {
        result += strArr[i++] + '\n';
      } else {
        result += strArr[i++].substring(0, maxWidth) + '\n';
      }
    } else {
      numberOfLine += 1;
      result += strArr[i++] + '\n';
    }
  }
  if (result.length > LENGTH_SEE_MORE_TEXT)
    return result.substring(0, result.length - LENGTH_SEE_MORE_TEXT);
  else return result;
};

export const checkStringNeedToBeSeeMore = (
  srcStr: string,
  maxLength: number,
  maxWidth: number
): boolean => {
  // 1 mean only 1 line
  if (numberOfNewLine(srcStr) <= 1) {
    return srcStr.length > maxLength;
  } else {
    return numberOfNewLine(srcStr) <= SUITABLE_TEXT_MAX_LINE
      ? maxWidthOfString(srcStr) > maxWidth
      : true;
  }
};

export const getAlphabeticalIndex = (index: number) => {
  return String.fromCharCode(65 + index);
};

export function formatCurrency(price: number) {
  return price
    .toLocaleString('vi-VN', {
      style: 'currency',
      currency: 'VND',
    })
    .replace('₫', 'VNĐ');
}

export function getFirst150Characters(str: string) {
  return str.substring(0, 150);
}

export function convertHtmlToPlainTextClient(htmlContent: string): string {
  if (typeof document === 'undefined') return '';

  // Create a temporary div element
  let tempDiv = document.createElement('div');

  document.body.appendChild(tempDiv);

  // Set the innerHTML of the div with the provided HTML content
  tempDiv.innerHTML = htmlContent;

  // Extract text content from the div
  let plainText = tempDiv.innerText || tempDiv.textContent || '';

  // Clean up: remove the temporary div from the document
  document.body.removeChild(tempDiv);

  return plainText;
}

export function removeBreakLinesAndSpaces(str: string): string {
  return str.replace(/\s/g, ' ');
}
